import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-e799af96"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "wrapper"
};

const _hoisted_2 = /*#__PURE__*/_createTextVNode("加载中...");

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_van_loading = _resolveComponent("van-loading");

  const _component_van_overlay = _resolveComponent("van-overlay");

  return _openBlock(), _createBlock(_component_van_overlay, {
    show: _ctx.$props.show,
    "lazy-render": "",
    "class-name": "declare-toast",
    "z-index": "998"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_component_van_loading, {
      vertical: "",
      color: "white",
      "text-color": "white"
    }, {
      default: _withCtx(() => [_hoisted_2]),
      _: 1
    })])]),
    _: 1
  }, 8, ["show"]);
}